export default "__VITE_ASSET__CeX8l7Fy__"